document.addEventListener("DOMContentLoaded", function () {
  var drawer = document.querySelector("[data-cart-drawer]");
  if (!drawer) return;

  var backdrop = document.querySelector("[data-cart-drawer-backdrop]");
  var itemList = drawer.querySelector("[data-cart-drawer-item-list]");
  var itemsWrapper = drawer.querySelector("[data-cart-drawer-items]");
  var viewAllLink = drawer.querySelector("[data-cart-drawer-view-all]");
  var emptyState = drawer.querySelector("[data-cart-drawer-empty]");
  var footer = drawer.querySelector("[data-cart-drawer-footer]");
  var countEl = drawer.querySelector("[data-cart-drawer-count]");
  var subtotalEl = drawer.querySelector("[data-cart-drawer-subtotal]");
  var totalEl = drawer.querySelector("[data-cart-drawer-total]");
  var shippingBar = drawer.querySelector("[data-cart-drawer-shipping-bar]");
  var shippingMessageEl = drawer.querySelector("[data-cart-drawer-shipping-message]");
  var shippingFillEl = drawer.querySelector("[data-cart-drawer-progress-fill]");

  var configEl = document.querySelector(
    '[data-section-type="static-cart-drawer"][data-section-data]'
  );
  var config = { settings: {}, free_shipping: {}, strings: {} };
  if (configEl) {
    try {
      config = JSON.parse(configEl.textContent);
    } catch (err) {
      // keep defaults
    }
  }

  var moneyFormat = (config.settings && config.settings.money_format) || "${{amount}}";

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return "$" + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  function sizedImageUrl(url, size) {
    if (!url) return "";
    return url.replace(/(\.[a-zA-Z0-9]+)(\?.*)?$/, "_" + size + "$1$2");
  }

  function renderItem(item) {
    var hasVariant = item.variant_title && item.variant_title !== "Default Title";
    var imageUrl = sizedImageUrl(item.image, "160x");

    return (
      '<li class="cart-drawer__item" data-cart-drawer-item data-cart-drawer-item-key="' +
      escapeHtml(item.key) +
      '">' +
      '<a href="' +
      escapeHtml(item.url) +
      '" class="cart-drawer__item-image">' +
      (imageUrl
        ? '<img src="' + escapeHtml(imageUrl) + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : "") +
      "</a>" +
      '<div class="cart-drawer__item-content">' +
      '<a href="' +
      escapeHtml(item.url) +
      '" class="cart-drawer__item-title">' +
      escapeHtml(item.product_title) +
      "</a>" +
      (hasVariant
        ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + "</div>"
        : "") +
      '<div class="cart-drawer__item-price money">' +
      formatMoney(item.final_price) +
      "</div>" +
      '<div class="cart-drawer__item-quantity" data-cart-drawer-qty-wrapper>' +
      '<button type="button" class="cart-drawer__qty-button" data-cart-drawer-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
      '<span class="cart-drawer__qty-value" data-cart-drawer-qty-value>' +
      item.quantity +
      "</span>" +
      '<button type="button" class="cart-drawer__qty-button" data-cart-drawer-qty-increase aria-label="Increase quantity">+</button>' +
      "</div>" +
      "</div>" +
      '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove aria-label="Remove ' +
      escapeHtml(item.product_title) +
      '">' +
      '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 6h16M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2m3 0-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>' +
      "</button>" +
      "</li>"
    );
  }

  function renderShippingBar(cart) {
    if (!shippingBar || !config.free_shipping || !config.free_shipping.enable) return;

    var threshold = parseInt(config.free_shipping.threshold, 10) || 0;
    if (threshold <= 0) {
      shippingBar.hidden = true;
      return;
    }

    shippingBar.hidden = false;
    var remaining = threshold - cart.total_price;
    var percent = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));

    if (shippingFillEl) shippingFillEl.style.width = percent + "%";

    if (remaining <= 0) {
      shippingMessageEl.textContent =
        config.free_shipping.reached_message || "You've unlocked free delivery!";
    } else {
      var template =
        config.free_shipping.progress_message ||
        "You're {{ amount }} away from free delivery!";
      shippingMessageEl.innerHTML = template.replace(
        "{{ amount }}",
        "<strong>" + formatMoney(remaining) + "</strong>"
      );
    }
  }

  function renderCart(cart) {
    var isEmpty = !cart.items || cart.items.length === 0;

    if (itemList) {
      itemList.innerHTML = isEmpty ? "" : cart.items.map(renderItem).join("");
    }

    if (itemsWrapper) itemsWrapper.hidden = isEmpty;
    if (viewAllLink) viewAllLink.hidden = !cart.items || cart.items.length <= 4;
    if (emptyState) emptyState.hidden = !isEmpty;
    if (footer) footer.hidden = isEmpty;

    if (countEl) countEl.textContent = "(" + cart.item_count + ")";
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    renderShippingBar(cart);
  }

  function open() {
    drawer.classList.add("cart-drawer--open");
    drawer.setAttribute("aria-hidden", "false");
    if (backdrop) backdrop.classList.add("cart-drawer__backdrop--visible");
    document.body.classList.add("cart-drawer-open");
  }

  function close() {
    drawer.classList.remove("cart-drawer--open");
    drawer.setAttribute("aria-hidden", "true");
    if (backdrop) backdrop.classList.remove("cart-drawer__backdrop--visible");
    document.body.classList.remove("cart-drawer-open");
  }

  function fetchCart() {
    return fetch(window.Theme.routes.cart_url + ".js").then(function (res) {
      return res.json();
    });
  }

  function changeItem(key, quantity) {
    return fetch(window.Theme.routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        renderCart(cart);
        window.dispatchEvent(new CustomEvent("cartcount:update", { detail: cart }));
      });
  }

  // Toggle open from the header cart icon (and any other trigger on the page)
  document.querySelectorAll("[data-cart-drawer-toggle]").forEach(function (trigger) {
    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      fetchCart().then(function (cart) {
        renderCart(cart);
        open();
      });
    });
  });

  drawer.querySelectorAll("[data-cart-drawer-close]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      close();
    });
  });

  if (backdrop) {
    backdrop.addEventListener("click", close);
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer.classList.contains("cart-drawer--open")) close();
  });

  // Quantity + remove controls, delegated since items re-render on every change
  if (itemList) {
    itemList.addEventListener("click", function (e) {
      var itemEl = e.target.closest("[data-cart-drawer-item]");
      if (!itemEl) return;

      var key = itemEl.getAttribute("data-cart-drawer-item-key");
      var qtyEl = itemEl.querySelector("[data-cart-drawer-qty-value]");
      var quantity = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;

      if (e.target.closest("[data-cart-drawer-qty-increase]")) {
        changeItem(key, quantity + 1);
      } else if (e.target.closest("[data-cart-drawer-qty-decrease]")) {
        changeItem(key, Math.max(0, quantity - 1));
      } else if (e.target.closest("[data-cart-drawer-remove]")) {
        changeItem(key, 0);
      }
    });
  }

  // Fires on every cart-count change site-wide (add to cart, cart page
  // updates, our own quantity/remove changes above) - see StaticHeader in
  // empire.js, which already listens to this same event for the header badge
  window.addEventListener("cartcount:update", function (e) {
    if (e.detail) renderCart(e.detail);
    open();
  });
});
